export function InputSkeletonLoader() {
  return (
    <div className="w-full rounded-full animate-pulse h-[44px] bg-blue-dark-sky-040 dark:bg-blue-dark-grey" />
  );
}
